define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/Controller",
	"csi/xml"
], function(declare,_,Controller,xml) {

	return declare(Controller, {
		toWriter: function() {
			this.widget.columnData.traverse(false, function(spec) {
				if (spec.columnUrl) {
					this.m_writer.callMethod("Specification", "SetSizeMapSize")
						.addParameter(xml.PROP_URL, xml.ATTR_REF, this.getParentURL())
						.addParameter("Source", xml.ATTR_REF, this.m_urlNode)
						.addParameter("Target", xml.ATTR_REF, spec.columnUrl);
				}
			}, this);
		},

		postProcessSuccess: function() {
			// summary: refresh rows
			this.widget.refreshDataRows();
		}
	});
});